import { useEffect } from "react";

type KeyboardListener = (e: KeyboardEvent) => void;

let listeners: KeyboardListener[] = [];

export function registerKeyboardListener(fn: KeyboardListener) {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
}

export function KeyboardManager() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleKey = (e: KeyboardEvent) => {
      // Ignore typing contexts
      const target = e.target as HTMLElement | null;
      if (
        target &&
        (target.tagName === "INPUT" ||
          target.tagName === "TEXTAREA" ||
          target.isContentEditable)
      ) {
        return;
      }

      // Dispatch to listeners
      listeners.forEach((fn) => fn(e));
    };

    window.addEventListener("keydown", handleKey, true);

    return () => {
      window.removeEventListener("keydown", handleKey, true);
    };
  }, []);

  return null;
}
